import { 
  scale,
    minus,
  distance,
  vectorAngleDegrees,
  } from './Geometry';

import MarkLabel from './MarkLabel';
import WhiskerLine from './WhiskerLine';

export default function LineSegment({setFocusedAnnotationId, defaultCropHeight,annotation,imgWidth,onDelete, isFocusedAnnotation, lsStyle, highlight, strokeColor, 
  guidelineType,
  guidelineSpec
}){


  let { rect, mark, ls, _id } = annotation;

  let x1,y1,x2,y2,stroke;
  let whiskers = [];
  let deleteButton;
  let outlineBox;
  let scaledLs;

  if(rect){

    console.log("Rect: " + JSON.stringify(rect));

    let scaledPointPath = rect.map(scale(imgWidth));

    let d = "M " + scaledPointPath.map(point => point.join(" ")).join(" L") + " Z";

    //;

    return <path id={"crop-box-preview"} d={d} class="lane-box" fill={"lime"} stroke={"blue"} strokeWidth={1}/>




  }else if( mark ){

    return <MarkLabel setFocusedAnnotationId={setFocusedAnnotationId} onDelete={onDelete} annotation={annotation} imgWidth={imgWidth} isFocusedAnnotation={isFocusedAnnotation}/>

  }else{

    if(!annotation.ls){
      throw(JSON.stringify(annotation));
    }

    scaledLs = annotation.ls.map(scale(imgWidth));

    [x1,y1] = scaledLs[0];
    [x2,y2] = scaledLs[1];


    stroke=strokeColor || 'blue';
  }

    

  let box;
  let strokeWidth = 1.5;


 
  let defaultDemoHeight = 20;

  let angle = (vectorAngleDegrees(minus(...scaledLs)));
  let rotation = "rotate("+[angle,...scaledLs[0]].join(',')+")";
  let translate = "translate(0,"+-(defaultCropHeight||defaultDemoHeight)/2+")";
  let transformation = rotation+" "+translate;


  if( true || annotation.choice === true ){
    strokeWidth = 3;  
    outlineBox = (
      <rect
        x={x1} y={y1} width={distance(...scaledLs)}
        height={defaultCropHeight}
        stroke={highlight?.includes(annotation.label)?"lime":"orange"}
        fill="none"
        strokeWidth="3"
        transform={transformation}
      />
    )


    //defaultCropHeight


  }


  box = highlight && (
    <rect
      x={x1} y={y1} 
      width={distance(...scaledLs)}
      height={defaultDemoHeight}
      stroke={highlight?.includes(annotation.label)?"lime":"orange"}
      fill="none"
      strokeWidth="3"
      transform={transformation}
    />
  )

  
  let fw = guidelineSpec?.w || 1;
  let fh = guidelineSpec?.h || 1;

  let ratio = fh/fw;

  let maxFDist = distance(...scaledLs);

  let fixedBox = (
      <rect
        x={x1-(maxFDist/2)} y={y1-(ratio*maxFDist)/2} 
        width={maxFDist}
        height={(maxFDist * ratio)}
        stroke={highlight?.includes(annotation.label)?"lime":"red"}
        fill="none"
        strokeWidth="3"
        transform={rotation}
      />
  )

  let manhattanWidth = Math.abs(x2-x1);
  let manhattanHeight = Math.abs(y2-y1);

  let equalGuide = manhattanHeight === manhattanWidth && (
    true
  )



    let squareWhiskers = [];
    if( Math.abs(manhattanWidth - manhattanHeight) < 1 ){
      squareWhiskers = [

        <WhiskerLine {...{
          x1,x2,
          y1:Math.max(y1,y2) + 10,
          y2:Math.max(y1,y2) + 10,
          stroke:"red",
          strokeWidth:1,
          whiskerLength:5,
        }}/>,

        <WhiskerLine {...{
          x1:Math.max(x1,x2) + 10,
          x2:Math.max(x1,x2) + 10,
          y1,
          y2,
          stroke:"red",
          strokeWidth:1,
          whiskerLength:5,
        }}/>



      ]
    }

  let uprightBox = (
    <>
      <rect
        stroke={"blue"}
        strokeWidth={3}
        fill={"none"}
        x={Math.min(x1,x2)}
        y={Math.min(y1,y2)}
        width={manhattanWidth}
        height={manhattanHeight}
      />
      {squareWhiskers}
    </>
  )




  return (
    <>

      {lsStyle==="box" && box}
      {outlineBox}
      {guidelineType === "upright" && uprightBox}
      {guidelineType==="fixedRatio" && fixedBox}
      <WhiskerLine {...{
        x1,y1,x2,y2,stroke,strokeWidth,

      }}/>
      {false && whiskers}



      



      {deleteButton}
    </>
  )
}
